import axios from "axios";
import mobizone from "../../router/mobizone";
import country_list from "../../locales/country_list.json";
import $ from "jquery";

const host = window.location.host;
const parts = host.split(".");
const currentDate = new Date();

const lang = window.navigator.userLanguage || window.navigator.language;
const language = lang.substring( 0, 2 ); 
let brwlang = localStorage.getItem("lang_mobiz");

if(language =='ms'){
  brwlang ='malay';
}else if(language =='ar'){
  brwlang ='arabic';
}else if(language =='el'){
  brwlang ='greek';
}else if(language =='bg' || parts[0] =='bg'){
  brwlang ='bulgarian';
}else if(language =='no' || parts[0] =='no'){
  brwlang ='norwegian';
}else if(language =='id'){
  brwlang ='indonesian';
}else if(language =='th'){
  brwlang ='thai';
}else if(language =='cs' || parts[0] =='cz'){
  brwlang ='czech';
}else if(language =='en'){
  brwlang ='english';
}

// setInterval(function(){ let d=new Date();console.log(d.getTime()); }, 500);

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

let res = Number(parts[1]);
let type = Number.isInteger(res);
let gcid = "";

if (type == true) {
  gcid = parts[1];
} else {
  gcid = "";
}

const state = {
  live: `http://cook.grabmobi.com`,
  local: `http://[::1]/PuretechGlobalContentPortal`,
  proxyurl: `http://api.allorigins.win/get?url=`,
  //allsubcategory
  allsubcategory_mobiz: {},
  //auth
  auth_mobiz: "",
  //hotpicks.vue
  pageHP_mobiz: {},
  //popular.vue
  pagePop_mobiz: {},
  //notification.vue
  notification_mobiz: {},
  //icon
  hotpickIcon_mobiz: require(`../../assets/mobizone/imgs/other/Hot Picks.svg`),
  popularIcon_mobiz: require(`../../assets/mobizone/imgs/other/Populars.svg`),
  langButton_mobiz: ``,
  country_mobiz: parts[0],
  host_mobiz: host,
  lang_mobiz: localStorage.getItem("lang_mobiz"),
  // lang_mobiz: brwlang,
  langcode_mobiz: "",
  type: "browse",
  gcid_mobiz: gcid,
  hpisLoad_mobiz: false,
  renew_date_mobiz: "",
  subscription_date_mobiz: "",
  status_mobiz: "",
  msisdn_mobiz: "",
  country_code: "",
  gateway_code: "",
  is_unsub: "0"
};

const getters = {
  langButton_mobiz: state => state.langButton_mobiz,
  lang_mobiz: state => state.lang_mobiz,
  gcid_mobiz: state => state.gcid_mobiz,
  country_mobiz: state => state.country_mobiz,
  allSubcategory_mobiz: state => state.allsubcategory_mobiz,
  pageHotPicks_mobiz: state => state.pageHP_mobiz,
  pagePopular_mobiz: state => state.pagePop_mobiz,
  HotPickIcon_mobiz: state => state.hotpickIcon_mobiz,
  PopularIcon_mobiz: state => state.popularIcon_mobiz,
  notification_mobiz: state => state.notification_mobiz,
  host_mobiz: state => state.host_mobiz,
  auth_mobiz: state => state.auth_mobiz,
  hpisLoad_mobiz: state => state.hpisLoad_mobiz,
  renew_date_mobiz: state => state.renew_date_mobiz,
  subscription_date_mobiz: state => state.subscription_date_mobiz,
  msisdn_mobiz: state => state.msisdn_mobiz,
  country_code: state => state.country_code,
  gateway_code: state => state.gateway_code,
  is_unsub_mobiz: state => state.is_unsub,
  status_mobiz: state => state.status_mobiz,
  langcode_mobiz: state => state.langcode_mobiz
};

const actions = {
  async fetchLocale_mobiz({ commit }, lang) {
    let lang_code = '';
    for (let [key, value] of Object.entries(country_list)) {
      if (lang == value.language) {
        lang = value.language;
        lang_code = value.lang_code
      } 
      // else {
      //   //english
      //   lang = lang;
      //   lang_code = 'en';
      // }
    }
    
    commit("setLanguageCode", lang_code);
    commit("setLanguage", lang);
  },
  async fetchTranslateButton_mobiz({ commit }, country) {
    for (let [key, value] of Object.entries(country_list)) {
      if (country == key) {
        let button = `<button id="lang2" lang="${value.language}" class="mobiBtn sm">
        <img lang="${value.language}" src="${value.flag_rec}" />
        <span lang="${value.language}">${value.button_text}</span>
        </button>`;

        commit("setButton", button);
      }
    }
  },
  async fetchAllSubcategory_mobiz({ commit }, subcategory) {
    //to get the subcategory translation
    let subcateg = await axios.get(
      `${state.live}/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=&subcategory=${subcategory}&limit=1&offset=0&domain=${host}`
    );

    commit("setAllSubcategory", subcateg.data.data);
  },
  async fetchPageHotPicks_mobiz({ commit }, file) {
    let data = file[0];

    let limit = 0;

    if (file[1] != undefined) {
      limit = parseInt(
        file[1].target.options[file[1].target.options.selectedIndex].value
      );
    } else {
      //default
      limit = 200;
    }

    let response = [];

    if (data == undefined) {
      response = await axios.get(
        `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=${limit}&offset=0&domain=${host}`
      );
    } else {
      response = await axios.get(
        `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=${data}&limit=${limit}&offset=0&domain=${host}`
      );
    }

    response.data.data.sort((a, b) =>
      a.cont_name_english.localeCompare(b.cont_name_english)
    );

    // console.log(response.data.data);

    commit("setPageHotPicks", response.data.data);
  },
  async fetchPagePopular_mobiz({ commit }, e) {
    let limit = 0;

    if (e != undefined) {
      limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
    } else {
      //default
      limit = 200;
    }

    let response = await axios.get(
      `${state.live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=&limit=${limit}&offset=0&domain=${host}`
    );

    response.data.data.sort(
      (a, b) =>
        // a.content_name.localeCompare(b.content_name),
        b.rating - a.rating
    );

    commit("setPagePopular", response.data.data);
  },
  async fetchToken_mobiz({ commit, dispatch }, id) {
    let auth = "";
    let check = "";

    let token = localStorage.getItem("userToken_mobiz");
    let userProfile = localStorage.getItem("userProfile_mobiz");

    let str = window.location.pathname;
    let path = str.split("/");
    path.pop();
    path = path.join("/");

    if (path == "") {
      path = "/home";
    }

    if (token != null) {
      //checking if have token
      auth = token;
    } else {
      //checking if have param id
      auth = id;
    }

    if (auth != undefined) {
      //to check if token has numbers and letters
      // check = dispatch("checkToken_mobiz", auth);
      // console.log(check)
      auth = auth.toLowerCase();
      var letterNumber = "^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$";
      if (auth.match(letterNumber)) {
        check = true;
      } else {
        check = false;
      }
    } else {
      mobizone.push({ name: "Login" }).catch(err => {});
    }

    if (check == true) {
      //if check is true
      let data = {
        code: auth,
        verbose: "1"
      };

      if (token != null) {
        localStorage.setItem("userToken_mobiz", data.code);
        commit("setUserProfile", JSON.parse(userProfile));
        commit("setAuth", "loggedin");
        // EventBus.$emit("logged-in", "loggedin");
      } else {
        let responses = await axios.post(
          `${state.proxyurl}`+ encodeURIComponent(`http://gateway.puretechglobal.net/gateway_request/api/sub/?code=${data.code}&verbose=${data.verbose}`)
        );
        var response = JSON.parse(responses.data.contents);
        if (response.status == "active") {
          localStorage.setItem("userToken_mobiz", data.code);
          localStorage.setItem("userProfile_mobiz",responses.data.contents);
          commit("setUserProfile", response);
          commit("setAuth", "loggedin");
          mobizone.push({ path: path }).catch(err => {});
          // location.reload();
        } else if (response.status == "inactive") {
          if (data.code != undefined) {
            alert(response.status.toUpperCase());
          }
          mobizone.push({ name: "Login" }).catch(err => {});
        }
      }
    } else {
      //if check is false
      mobizone.push({ name: "Login" }).catch(err => {});
    }
  },
  async getDomain_mobiz({ commit }, host) {
    let response = await axios.get(
      `${state.live}/api/domain?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6`
    );

    let dom = response.data.data;
    dom = dom.filter(item => {
      return item.domain == host;
    });

    let domain = "";

    if (dom != "") {
      domain = dom[0].is_unsub;

      if (dom[0].gateway_id != "0") commit("setGatewayID", dom[0].gateway_id);
    } else {
      domain = "0";
    }
    commit("setUnsubButton", domain);
  },
  async checkToken_mobiz({ commit }, auth) {
    var letterNumber = /^[A-Za-z0-9][A-Za-z0-9 ]\*[A-Za-z0-9]\*$/;
    if (auth.match(letterNumber)) {
      return true;
    } else {
      return false;
    }
  },
  async subContent_mobiz({ commit }, file) {
    let token = localStorage.getItem("userToken_mobiz");
    let lang = localStorage.getItem("lang_mobiz");
    let alert_pop = "";

    let alert_lang = require(`../../locales/mobizone/${lang}.json`);
    alert_pop = alert_lang.not_subs;
    if (token != null) {
      if (file[1] != "application/x-zip-compressed") {
        axios.post(`${state.live}/api/newcontents_statistic`, {
          token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
          country: state.country_mobiz,
          product: 'mobizone',
          content_id: file[2],
          type: "download"
        })
        window.location.href = file[0];
        // window.open(file[0], "download");
      } else {
        axios.post(`${state.live}/api/newcontents_statistic`, {
          token: 'xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6',
          country: state.country_mobiz,
          product: 'mobizone',
          content_id: file[2],
          type: "play"
        })

        window.open(file[0], "_blank");
      }
    } else {
      alert(alert_pop);

      setTimeout(() => {
        mobizone.push({ name: "Login" }).catch(err => {});
      }, 1000);
    }
  },
  async login_mobiz({ commit }, loginAuth) {
    commit("setAuth", loginAuth);
  },
  async fetchNotification_mobiz({ commit }) {
    let notify = [];
    let date = currentDate.getUTCDate();
    let w = week % 2;

    if (w != 0) {
      date = date + 10;
    }

    let res = await axios.get(
      `${state.live}/api/contents/newcontents_notification?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&domain=${host}`
    );

    let data = res.data.data;
    let noti = data.map(noti => {
      noti.titleSub_english = noti.subcategory;
      if (noti.subcategory_translate != null) {
        let sub_trans = JSON.parse(noti.subcategory_translate);
        if (sub_trans != null) {
          let trans_len = Object.keys(sub_trans).length;
          let trans_arr = Object.keys(sub_trans);

          if (sub_trans != null || sub_icon != null) {
            for (let i = 0; i < trans_len; i++) {
              noti["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
            }
          }
        }
      }
      return noti;
    });

    // if(w == 0){
    //   //name ascending
    //   noti.sort((a, b) => a.content_name.localeCompare(b.content_name))
    // }else{
    //   //name descending
    //   noti.sort((a, b) => b.content_name.localeCompare(a.content_name))
    // }

    // notify = noti.slice(0,5);

    commit("setNotification", noti);
  },
  async logout_mobiz({ commit }, is_unsub) {
    if (is_unsub != "0") {
      let token = localStorage.getItem("userToken_mobiz");
      let responses = await axios.post(`${state.proxyurl}`+ encodeURIComponent(`http://api.puretechglobal.net/gateway_request/${state.country_code}/${state.gateway_code}/unsub.php?code=${token}&msisdn=${state.msisdn_mobiz}`)
      );
      var response = JSON.parse(responses.data.contents);
      removeStorage();
      $("#exampleModalCenter").modal("hide");
      if (responses.data.contents == 'success' || response.status =='success') {
        if (state.country_mobiz == "iq") {
          mobizone.push({ name: "Unsubscription" }).catch(err => {});
        } else {
          mobizone.push({ name: "Login" }).catch(err => {});
        }
      }
    } else {
      removeStorage();
      if (state.country_mobiz == "iq") {
        $("#exampleModalCenter").modal("hide");
        mobizone.push({ name: "Unsubscription" }).catch(err => {});
      } else {
        mobizone.push({ name: "Login" }).catch(err => {});
      }
    }

    function removeStorage() {
      localStorage.removeItem("userProfile_mobiz");
      localStorage.removeItem("userToken_mobiz");
      localStorage.removeItem("logged-in");
      commit("setAuth", "");
    }
  }
};

const mutations = {
  setPageHotPicks: (state, response) => (state.pageHP_mobiz = response),
  setPagePopular: (state, response) => (state.pagePop_mobiz = response),
  setNotification: (state, response) => (state.notification_mobiz = response),
  setAuth: (state, response) => (state.auth_mobiz = response),
  setButton: (state, response) => (state.langButton_mobiz = response),
  setLanguage: (state, response) => (state.lang_mobiz = response),
  setLanguageCode: (state, response) => (state.langcode_mobiz = response),
  setAllSubcategory: (state, response) => (state.allsubcategory_mobiz = response),
  setUserProfile: (state, response) => {
    // format date to dd-mm-yyy
    const subscription_date = new Date(response.subscription_date);

    const dateTimeFormat = new Intl.DateTimeFormat("en", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });

    const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat.formatToParts(subscription_date);
    const sub_date = `${day}-${month}-${year}`;

    let renew_date = '';
    if(response.next_renew_date != '' &&  response.next_renew_date != '0000-00-00'){
      const next_renew_date = new Date(response.next_renew_date);
      const dateTimeFormat1 = new Intl.DateTimeFormat("en", {
        year1: "numeric",
        month1: "2-digit",
        day1: "2-digit"
      });

      const [{ value: month1 },,{ value: day1 },,{ value: year1 }] = dateTimeFormat1.formatToParts(next_renew_date);
      renew_date = `${day1}-${month1}-${year1}`;
    }else{
      renew_date = response.next_renew_date;
    }

    return (
      (state.status_mobiz = response.status),
      (state.renew_date_mobiz = renew_date),
      (state.subscription_date_mobiz = sub_date),
      (state.msisdn_mobiz = response.msisdn),
      (state.country_code = response.country_code),
      (state.gateway_code = response.gateway_code)
    );
  },
  setGatewayID: (state, response) => (state.gcid_mobiz = response),
  setUnsubButton: (state, response) => (state.is_unsub = response)
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/mobizone-store.js